( function ( _s ) {
	_s.fn.accordion = function () {
		return this.el.forEach( el => {
			const _self = _s( el );
			const _accordionItemsContainer = _self.find( '> ul' );

			const checkPosition = _accordionItem => {
				const accordionItem = _accordionItem.firstElement();

				if ( _accordionItem.offset().top < window.scrollY ) {
					accordionItem.scrollIntoView();
				}
			};

			_accordionItemsContainer.on( 'shown.bs.collapse', e => {
				const _expanded = _s( e.target ).closest( 'li' );

				if ( _expanded.length ) {
					checkPosition( _expanded );
				}
			} );

			const onResizeComplete = () => {
				window.navbarLocked = false;
			};

			const observeHeightChanges = element => {
				const debouncedOnResizeComplete = window.debounce( onResizeComplete, 500 );

				const resizeObserver = new ResizeObserver( entries => {
					entries.forEach( () => {
						window.navbarLocked = true;
						debouncedOnResizeComplete();
					} );
				} );

				resizeObserver.observe( element );
			};

			observeHeightChanges( _accordionItemsContainer.firstElement() );
		} );
	};

	_s( document ).ready( () => {
		_s( '.module.sp-accordion.accordion' ).accordion();
	} );
} )( window._s );
